export const mainLayout = {
  container: 'flex flex-row',
  navigation: 'w-full',
  main: 'w-1/2 h-screen flex flex-col items-center relative left-1/4',
  header: 'w-1/4 flex h-full flex-col items-end fixed left-0 ',
  aside: 'w-1/4 flex h-full flex-col items-start fixed right-0 ',
};

export const alternativeLayout = {
  container: 'flex flex-row',
  navigation: 'w-full',
  default: {
    main: 'w-3/4 h-screen flex flex-col items-center relative left-1/4',
    header: 'w-1/4 h-full flex flex-col items-end fixed left-0',
    aside: 'w-1/4 h-full flex flex-col items-start fixed right-0',
  },
  expanded: {
    main: 'w-1/2 h-screen flex flex-col items-center relative left-1/4',
    header: 'w-1/4 flex flex-col items-end fixed left-0',
    aside: 'w-1/4 flex flex-col items-start fixed right-0',
  },
};

export const wrapper = {
  main: {
    aside:
      'py-4 px-7 absolute top-0 bottom-0 overflow-y-auto w-full border-[#9e9e9e4f] border-l-2',
    header:
      'py-4 px-7 absolute top-0 bottom-0 overflow-y-auto w-full border-[#9e9e9e4f] border-r-2',
    main: 'py-4 px-7 mobile:w-full tablet-lg:w-[500px] mx-auto',
    'alt-navigation': 'mobile:w-full tablet-lg:w-[500px] py-4 px-7',
    'info-navigation': '',
  },
  alternate: {
    aside:
      'py-4 px-7 absolute top-0 bottom-0 overflow-y-auto w-full border-[#9e9e9e4f] border-l-2',
    header:
      'py-4 px-7 absolute top-0 bottom-0 overflow-y-auto w-full border-[#9e9e9e4f] border-r-2',
    main: 'w-full m-auto',
    'alt-navigation': 'py-4 px-16 w-full m-auto',
    'info-navigation': 'py-0 px-16 w-full m-auto',
  },
};

export const navigation = {
  container: '',
  wrapper: 'flex flex-col',
  list: 'flex flex-col gap-y-4',
  'link-item': 'flex flex-row items-center gap-x-5',
};

export const main = {
  container: '',
};

export const aside = {
  container: '',
};

export const hbarGap = {
  xs: 'my-0.5',
  sm: 'my-1.5',
  base: 'my-2.5',
  lg: 'my-5',
  xl: 'my-10',
  none: '',
};

export const hbarSize = {
  sm: 'h-[1px]',
  base: 'h-[2px]',
  lg: 'h-[3px]',
};

export const spaceMinified = {
  container: 'flex flex-row gap-x-3.5 items-center',
};

export const alternateNavigation = {
  container: 'flex flex-row gap-x-5 justify-end items-center',
};

export const stackWrap = {
  reverse: 'flex-wrap-reverse',
  default: 'flex-nowrap',
  wrap: 'flex-wrap',
};

export const stackJustify = {
  evenly: 'justify-evenly',
  between: 'justify-between',
  start: 'justify-start',
  end: 'justify-end',
  center: 'justify-center',
  around: 'justify-around',
};

export const stackAlign = {
  evenly: 'items-evenly',
  between: 'items-between',
  start: 'items-start',
  end: 'items-end',
  center: 'items-center',
  around: 'items-around',
};

export const stackGap = {
  xs: 'gap-0.5',
  sm: 'gap-2.5',
  base: 'gap-5',
  md: 'gap-8',
  lg: 'gap-10',
  xl: 'gap-20',
  none: 'gap-0',
};

export const stackDirection = {
  vertical: 'flex-col',
  horizontal: 'flex-row',
  'horizontal-reverse': 'flex-row-reverse',
  'vertical-reverse': 'flex-col-reverse',
};
